import { render } from "./px-tabs-mobile.vue?vue&type=template&id=94c17a66&ts=true"
import script from "./px-tabs-mobile.vue?vue&type=script&lang=ts"
export * from "./px-tabs-mobile.vue?vue&type=script&lang=ts"

import "./px-tabs-mobile.vue?vue&type=style&index=0&id=94c17a66&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__